function getCookieValueByPartialName(partialName) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(partialName) === 0) {
      const separatorIndex = cookie.indexOf('=');
      if (separatorIndex !== -1) {
        return cookie.substring(separatorIndex + 1);
      }
    }
  }
  return null;
}

function SendToLeadLegend1(firstName, lastName, email, company, phone, lltk, ipAddress, pageUrl, pageName){

    fetch('http://leadlegendclient.ca-central-1.elasticbeanstalk.com/api/contacts/contactSubmit', {

        method: 'POST',

        mode: 'no-cors',

        headers: {

            'Accept': '*/*',

            'Access-Control-Allow-Origin' : '*',

            'Accept-Encoding': 'gzip, deflate',

            'Cache-Control': 'no-cache, no-cache',

            'Connection': 'keep-alive',

            'Content-Length': '309',

            'Content-Type': 'application/json',

            'Host': 'localhost:3005',

            'Postman-Token': 'f6599a07-be12-4839-b347-032b29665b8c,7dd5afec-4512-44b0-a14b-364942aae093',

            'User-Agent': 'PostmanRuntime/7.19.0'

        },

        body: JSON.stringify({

            'firstName': firstName,

            'lastName': lastName,

            'email': email,

            'company': company,

            'phone': phone,

            'll_context': {

                'lltk': lltk, //Usually the cookie, see the WP version on how to fetch it.

                'ipAddress': ipAddress, //The users IP address, how to get this should be clear based on platform

                'pageUrl': pageUrl,

                'pageName': pageName

            }

        })

    });

}

// var form = $("#contact_form");
// form.one("submit", function(event) {
//     event.preventDefault();

//     var firstName = form.find("#contact_name']").val();
//     var email = form.find("#contact_email").val();
//     var phone = form.find("#contact_phone").val();
//     var message = form.find("#contact_message").val();
//     var lastName = '';
//     var company = '';
//     var ipAddress = '';
  
//     $.getJSON("https://api.ipify.org/?format=json", function(e) {
//     var ipAddress = e.ip;
//     });
  
//     var pageUrl = window.location.href;
//     var pageName = $(document).find("title").text();
//     var lltk = getCookieValueByPartialName('_pk_id');
  
//     SendToLeadLegend(firstName, lastName, email, company, phone, lltk, ipAddress, pageUrl, pageName, message);
  
//     $(this).submit();

// });